export const STATUSES_TYPES = {
  accepted: 'accepted',
  performed: 'performed',
  shipped_to_store: 'shipped_to_store',
  ready_to_issue: 'ready_to_issue',
  shipped: 'shipped',
  prepared: 'prepared',
  cancelled: 'cancelled',
  at_pickup: 'at_pickup',
  waiting_assembly: 'waiting_assembly',
  in_work: 'in_work',
};

const STATUSES = {
  [STATUSES_TYPES.accepted]: 'В обработке',
  [STATUSES_TYPES.performed]: 'Выполнен',
  [STATUSES_TYPES.shipped_to_store]: 'Доставляется в магазин',
  [STATUSES_TYPES.ready_to_issue]: 'Ожидает в магазине',
  [STATUSES_TYPES.shipped]: 'Доставляется',
  [STATUSES_TYPES.prepared]: 'Собирается',
  [STATUSES_TYPES.cancelled]: 'Отменён',
  [STATUSES_TYPES.waiting_assembly]: 'Ожидает сборки',
  [STATUSES_TYPES.in_work]: 'Сборка на складе',
  [STATUSES_TYPES.at_pickup]: 'Ожидает в пункте выдачи',
};

export const getOrderStatus = (status: keyof typeof STATUSES_TYPES) => STATUSES[status] ?? STATUSES.accepted;
